<template>
    
    <div>
        <naj-alert v-if="showJudgementDeliveryDateNote && judgments && judgments.length > 0" type="information">
            <template slot="content">
                {{ local.caseFile.noJudgementLine1 }}{{ local.caseFile.noJudgementLine2 }}{{toHijriDate(nearestDeliveryDate)}}{{ local.caseFile.hijri }}
            </template>
        </naj-alert>
        <v-card flat
                :loading="loading"
                class="tab-details">
            <v-progress-linear v-if="loading"
                               indeterminate
                               color="primary"></v-progress-linear>
            <v-card-text>
                <div class="mx-12 text-h6 font-weight-black mt-3 text-c-green">
                    {{ local.caseFile.tabHeaders.judgements }}
                </div>
                <v-row class="mx-12">
                    <template v-for="(item, index) in judgments">
                        <v-col :key="index"
                               cols="4">
                            <judgement-card :judgement="item"
                                            :case-object-key="caseObjectKey"
                                            :is-pega="isPega"
                                            :has-actions="item.executionEnabled"
                                            @judgement-card-click="openJudgementInfo(item)">
                                <template v-if="item.executionEnabled"
                                          slot="actions"
                                          slot-scope="{}">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-icon large v-on="on">
                                                mdi-dots-vertical
                                            </v-icon>
                                        </template>
                                        <v-list>
                                            <v-list-item>
                                                <v-list-item-title>
                                                    <naj-button text
                                                                type="button"
                                                                size="small"
                                                                @click="showExecutionInfoModal(item)">
                                                        {{ local.caseFile.cards.judgement.execution.newRequest }}
                                                    </naj-button>
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-title>
                                                    <naj-button text
                                                                type="button"
                                                                size="small"
                                                                @click="showExecutionRequests(item)">
                                                        {{ local.caseFile.cards.judgement.execution.myRequests }}
                                                    </naj-button>
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </judgement-card>
                        </v-col>
                    </template>
                    <v-col cols="12">
                        <naj-no-data :has-data="judgments && judgments.length > 0"
                                     :loading="loading" :noDataMessage="showJudgementDeliveryDateNote ? local.caseFile.noJudgementsOnThisCase : null"
                                     :noDataMessageLine2="showJudgementDeliveryDateNote? local.caseFile.judgementToBe + toHijriDate(nearestDeliveryDate) + local.caseFile.hijri : null"></naj-no-data>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <degree-color-palette></degree-color-palette>

        <pdf-judgements-modal :judgements="judgments"
                              :selected-judgement-index-prop="selectedJudgementIndex"
                              :modal-visibility="showJudgementInfoModal"
                              @modalClose="closeJudgementInfo"></pdf-judgements-modal>

        <naj-alert-modal :show-modal="showAlertModal"
                         type="information"
                         :title="local.caseFile.secretJudgementsInfoTitle"
                         :message="local.caseFile.secretJudgementsInfo"
                         @onCancelModal="showAlertModal=false">
        </naj-alert-modal>

        <judgement-execution :modal-visibility="showExecutionRequestInfoModal && !isVacationPeriod" 
                             @modalClose="hideExecutionRequestInfoModal"
                             :judgement="selectedJudgementForExecution"
                             @executionRequestSuccessfullySent="showRequestNumber">

        </judgement-execution>

        <agent-judgement-execution :modal-visibility="showAgentExecutionRequestInfoModal && !isVacationPeriod"
                                   @modalClose="hideExecutionRequestInfoModal"
                                   :judgement="selectedJudgementForExecution"
                                   @executionRequestSuccessfullySent="showRequestNumber">
        </agent-judgement-execution>

        <request-list :modal-visibility="showExecutionRequestsModal"
                      @modalClose="hideExecutionRequests"
                      :judgement="selectedJudgementForExecution">

        </request-list>
        <naj-confirmation :show-modal="showSentInformationModal"
                          :max-width="750"
                          :title="local.caseRelatedRequest.successAlertMessage"
                          :close-btn-label="local.common.close"
                          @cancel="closeSentInformationModal">
            <template slot="message-content">
                <v-row>
                    <v-col>
                        <naj-alert type="success">
                            <template slot="content">
                                {{requestSentMessage}}
                            </template>
                        </naj-alert>
                    </v-col>
                </v-row>
            </template>
        </naj-confirmation>
        <naj-confirmation :show-modal="showVacationModal"
                          :title="vacationModal.title"
                          :message="vacationModal.message"
                          :close-btn-label="local.common.close"
                          @cancel="showVacationModal = false"></naj-confirmation>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import JudgementCard from '../../../../global/components/cards/judgement-card.vue';
import PdfJudgementsModal from '../../../pdf-judgements-modal';
const { mapActions } = createNamespacedHelpers('CasesModule');
const { mapActions: mapGlobalActions, mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
import {  userType } from '@/helpers/enum';
import DegreeColorPalette from '../degree-color-palette';
import { toHijriDate } from '@/helpers/utils';
import JudgementExecution from '../../../../global/components/judgement-execution/request-info.vue';
import RequestList from '../../../../global/components/judgement-execution/request-list.vue';
import AgentJudgementExecution from '../../../../global/components/judgement-execution/agent-request-info.vue';
import Vacations from '@/modules/lawsuit/services/vacations';

import { socialIdentityTypeEnum, casePartyRoleEnum } from '@/helpers/enum';




export default {
  name: 'CaseJudgmentsTab',
  components: {
    JudgementCard,
    PdfJudgementsModal,
    DegreeColorPalette,
    JudgementExecution,
    RequestList,
    AgentJudgementExecution,
  },
  props: {
    caseObjectKey: {
      type: String,
      required: true,
    },
    isPega: {
      type: String,
      required: true,
    },
    isSecretJudgements: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      judgments: [],
      loading: false,
      selectedJudgementIndex: 0,
      showJudgementInfoModal: false,
      showExecutionRequestsModal: false,
      showAlertModal: false,
      futureDeliveryDate: String,
      showExecutionRequestInfoModal: false,
      showAgentExecutionRequestInfoModal: false,
      showVacationModal: false,

      isVacationPeriod : false,
      vacationModal: {
        title: null,
        message: null,
      },
      formModel: {},
        selectedJudgementForExecution: {},
        requestSentMessage: '',
        showSentInformationModal: false,
        userCasePartyRoleInCase: {},
    };
        },
   computed: {
       ...mapGlobalState(['userInfo']),
       nearestDeliveryDate() { return this.futureDeliveryDate; } ,
       showJudgementDeliveryDateNote() {           
       return (this.futureDeliveryDate !== undefined && this.futureDeliveryDate !== null && this.futureDeliveryDate !== "");
       },
       isAgent() {
           if (this.userInfo && (this.userInfo.userType == userType.najizOrganization || this.userInfo.userType == userType.najizLawyer))
               return true;
           if (this.userCasePartyRoleInCase.roleInCaseId == casePartyRoleEnum.agent ||
               this.userCasePartyRoleInCase.roleInCaseId == casePartyRoleEnum.lawyer ||
               this.userCasePartyRoleInCase.roleInCaseId == casePartyRoleEnum.representative) {
               return true;
           }
           return false;
       },
   },
   mounted() {
      this.loadData();
      this.getNearestDeliveryDate();
      const params = {
          isPega: true,
          objectKey: this.caseObjectKey,
      };
      Promise.all([
          this.getIcmsUserRoleFromCasePartyRolesInCase(this.caseObjectKey),
          this.getCaseBasicParties(params),
          
      ]).then((res) => {
          this.userCasePartyRoleInCase = res[0].data;
          this.basicCasePartiesInfo = res[1].data;
      })
          .finally(() => (this.loading = false));

  },
   methods: {
    ...mapGlobalActions(['getUserInfo']),
    ...mapActions([
        'getCaseJudgments',
        'getNearestJudgement',
        'getIcmsUserRoleFromCasePartyRolesInCase',
        'getCaseBasicParties',
    ]),
       checkVacation() {
      const service = Vacations.check();

      if (service.locked) {
        this.vacationModal = {
          title: this.local.lawsuitRequest.serviceNotAvailable,
          message: service.message,
        };

        this.showVacationModal = true;

          this.isVacationPeriod = true;
      } else {
        this.showVacationModal = false;
      }
    },
    loadData() {
      const params = {
        objectKey: this.caseObjectKey,
        isPega: this.isPega == 'true',
      };
      this.loading = true;
      this.getCaseJudgments(params)
        .then((res) => {
          this.judgments = res.data;
        })
        .catch(err => this.toaster.error(err.message))
        .finally(() => (this.loading = false));

    },
    openJudgementInfo(judgement) {
      if (this.isSecretJudgements) {
        this.showAlertModal = true;
      } else {
        this.showJudgementInfoModal = true;
        this.selectedJudgementIndex = this.judgments.findIndex(a => a.id == judgement.id);
      }
    },
    closeJudgementInfo() {
      this.showJudgementInfoModal = false;
      this.selectedJudgementIndex = 0;
      },
      showRequestNumber(data) {
          this.showSentInformationModal = true;
          this.requestSentMessage = this.local.caseFile.cards.judgement.execution.requestSentSuccessfully.replace('$$$$', data);
      },
      closeSentInformationModal() {
          this.showSentInformationModal = false;
      },
    toHijriDate,
    getNearestDeliveryDate() {
          var objectKey = this.$route.params.caseObjectKey;
          this.getNearestJudgement(objectKey)
              .then(({ data }) => {
                  this.futureDeliveryDate = data;
              });
      },
      showExecutionInfoModal(item) {
          this.checkVacation();
          this.selectedJudgementForExecution = item;

          if (!this.isAgent)
              this.showExecutionRequestInfoModal = true;
          else
              this.showAgentExecutionRequestInfoModal = true;
      },
      hideExecutionRequestInfoModal() {
          if (!this.isAgent)
              this.showExecutionRequestInfoModal = false;
          else
              this.showAgentExecutionRequestInfoModal = false;
      },
      showExecutionRequests(item){
          this.selectedJudgementForExecution = item;
          this.showExecutionRequestsModal = true;
      },
      hideExecutionRequests(){
          this.showExecutionRequestsModal = false;
      }
  },
};

</script>

<style lang="scss" scoped>
</style>